import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';
import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';

import * as loglevel from 'config/loglevel';

import types from '../actionTypes';

const { takeEvery } = sagaEffects;

function* handler() {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();
    try {
        yield firestore.setListener({
            collection: `imports`,
            storeAs: 'lastImport',
            orderBy: ['startAt', 'desc'],
            limit: 1,
        });
    } catch (e) {
        loglevel.error(e);
        message.error(intl.formatMessage({ id: 'errors.imports.listenImport' }));
    }
}

export default function* () {
    yield takeEvery(types.LISTEN_LAST_IMPORT, handler);
}
